define.alias("shared/components/shared/mavely/links/folders-tab", "media/components/shared/mavely/links/folders-tab");